import { A, AnchorProps } from './A';

export const MailTo = (props: AnchorProps): React.ReactElement<any, any> | null => {
    return <A {...props} icon="envelope" prefix="mailto" />;
};
